export default __webpack_public_path__ + "images/media-dummy-140.da11124ce8b87406bb0f56a357cc15d1.svg";